import React, { useState } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { BhiFormDialog, Button } from 'src/UIKit';

interface ContactConsentModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ContactConsentModal: React.FC<ContactConsentModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const [isAccepting, setIsAccepting] = useState(false);

  const handleClose = () => {
    setIsAccepting(false);
    onClose();
  };

  const handleConfirm = () => {
    if (isAccepting) {
      onConfirm();
      setIsAccepting(false);
    }
  };

  return (
    <BhiFormDialog
      open={open}
      onClose={handleClose}
      title="Add Contact"
      actions={
        <>
          <Button onClick={handleClose} variant="outlined">Cancel</Button>
          <Button onClick={handleConfirm} variant="contained" disabled={!isAccepting}>
            Save Contact
          </Button>
        </>
      }
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={isAccepting}
            onChange={event => setIsAccepting(event.target.checked)}
            name="consent-checkbox"
            color="primary"
          />
        }
        label="I confirm that I have received express consent to message the contacts that I am adding."
      />
    </BhiFormDialog>
  );
};

export default ContactConsentModal;
